import AbsItemList from "./AbsItemList";

class ListSkill extends AbsItemList{
    constructor(_store={}, _router={}, _el=''){
        super('class ListSkill', _store, _router, _el);

        this.dbParam = 'skillid';

        let watchSkillId = this.watch(this.store.getState, 'skillId', this.isEqual);
        this.store.subscribe( watchSkillId( (newVal, oldVal, path) => {
            $(this.el + ' .gd-result-list').find('li.is-active').removeClass('is-active');
            $(this.el + ' .gd-result-list').find(`li[data-id="${newVal}"]`).addClass('is-active');
        } ) );

        let watchselTypesOper = this.watch(this.store.getState, 'selTypesOper', this.isEqual);
        this.store.subscribe( watchselTypesOper( (newVal, oldVal, path) => this.selChange(newVal, oldVal, path)));

        let watchselTypes = this.watch(this.store.getState, 'selType', this.isEqual);
        this.store.subscribe( watchselTypes( (newVal, oldVal, path) => this.selChange(newVal, oldVal, path)));

        let watchRaceId = this.watch(this.store.getState, 'selRaceId', this.isEqual);
        this.store.subscribe( watchRaceId( (newVal, oldVal, path) => this.selChange(newVal, oldVal, path)));

        let watchClassId = this.watch(this.store.getState, 'selClassId', this.isEqual);
        this.store.subscribe( watchClassId( (newVal, oldVal, path) => this.selChange(newVal, oldVal, path)));

        let watchLvMin = this.watch(this.store.getState, 'selLvMin', this.isEqual);
        this.store.subscribe( watchLvMin( (newVal, oldVal, path) => this.selChange(newVal, oldVal, path)));

        let watchselLvMax = this.watch(this.store.getState, 'selLvMax', this.isEqual);
        this.store.subscribe( watchselLvMax( (newVal, oldVal, path) => this.selChange(newVal, oldVal, path)));


        let st = this.store.getState();
        if ( st.query || st.selTypesOper || st.selType || st.selRaceId || st.selClassId || st.selLvMin || st.selLvMax ) {
            this.store.dispatch( this.actions.loadItemList() );
        }else{
            this.store.dispatch( this.actions.loadPopular() );
        }
    }

    singleObj(it){
        let li_el = $(`
        <li data-id="${it.skillId}" ${it.skillId==this.store.getState().skillId?'class="is-active"':''}>
            <button class="gd-result-list-link" data-id="${it.skillId}">
                <div class="gd-result-main-info">
                    <span class="gd-info-img-wrap"><img src="${it.image}" alt="${it.name.replace(/</g,'&lt;').replace(/>/g,'&gt;')}" onerror="this.src='https://assets.playnccdn.com/plaync/gamedictionary/v1/img/default.png';"></span>
                    <div class="gd-info-text-wrap">
                        <div class="gd-info-text">
                            <span class="gd-info-text-inner">
                                <span class="gd-info-main-text">${it.name.replace(/</g,'&lt;').replace(/>/g,'&gt;')}${it.getLevel? ` <em>Lv ${it.getLevel} 습득</em>`: ``}</span>
                            </span>
                        </div>
                        <em class="gd-info-tag-wrap">
                            <span class="gd-info-tag">${it.iconTypeName}</span>
                        </em>
                    </div>
                </div>
            </button>
        </li>`);
        li_el.on('click', (e)=>{
            li_el.addClass('is-active');
            this.store.dispatch( this.actions.addRecentList({id: it.skillId, name: it.name, image: it.image, db: this.dbParam}));
            this.store.dispatch( this.actions.setUserselect(true));
            this.store.dispatch( this.actions.setDetailIsshow(true));
            this.router.goSingleParam( this.dbParam, it.skillId );
        });
        return li_el;
    }

} // end of class
export default ListSkill;